import { useNavigationContext } from '../../../contexts/NavigationContext';
import ResourcePage from './resource/ResourcePage';
import ProgramPage from './program/ProgramPage';
import './BanquetCeleste.scss';
import MainLayout from '../../../components/Display/MainLayout';


function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <MainLayout enableAnalytics={true} scope={'banquetceleste'} websiteLabel={"banquet-celeste.fr"}>
      <ProgramPage isActive={navigationContext.activeAppKey === 'program'} />
      <ResourcePage isActive={navigationContext.activeAppKey === 'resource'} />
    </MainLayout>

  );
}

export default Home;
